import { MODOS, type Modo, type Moneda } from '@rumbo/form'
import { Boton, Entrada, Seleccion } from '@/componentes/ui'

export interface TramoUI {
  orden: number
  modo: Modo
  minutos: number
  gasto?: { monto: string; moneda: Moneda }
}

/** Editor de tramos para un viaje multimodal (hasta 5, opcional). */
export function TramosEditor({ tramos, onCambio }: { tramos: TramoUI[]; onCambio: (t: TramoUI[]) => void }) {
  const agregar = () => {
    if (tramos.length >= 5) return
    onCambio([...tramos, { orden: tramos.length + 1, modo: 'autobus_publico', minutos: 10 }])
  }
  const quitar = (i: number) => onCambio(tramos.filter((_, k) => k !== i).map((t, k) => ({ ...t, orden: k + 1 })))
  const cambiar = (i: number, cambios: Partial<TramoUI>) => onCambio(tramos.map((t, k) => (k === i ? { ...t, ...cambios } : t)))

  return (
    <div className="space-y-3">
      {tramos.map((t, i) => (
        <div key={i} className="rounded-[var(--radius-rumbo)] border border-borde-fuerte p-3">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-sm font-medium text-texto">Tramo {t.orden}</span>
            <button type="button" onClick={() => quitar(i)} className="foco-visible rounded px-2 py-1 text-sm text-critico hover:bg-critico-fondo">
              Quitar
            </button>
          </div>
          <div className="grid gap-2 sm:grid-cols-3">
            <Seleccion aria-label="Modo del tramo" value={t.modo} onChange={(e) => cambiar(i, { modo: e.target.value as Modo })}>
              {MODOS.map((m) => (
                <option key={m.valor} value={m.valor}>
                  {m.etiqueta}
                </option>
              ))}
            </Seleccion>
            <Entrada type="number" min={1} max={240} aria-label="Minutos" placeholder="Minutos" value={t.minutos} onChange={(e) => cambiar(i, { minutos: Number(e.target.value) })} />
            <div className="flex gap-1.5">
              <Entrada
                type="number"
                min={0}
                step="0.01"
                aria-label="Gasto del tramo"
                placeholder="Gasto (opcional)"
                value={t.gasto?.monto ?? ''}
                onChange={(e) => cambiar(i, { gasto: { monto: e.target.value, moneda: t.gasto?.moneda ?? 'VES' } })}
              />
              <Seleccion aria-label="Moneda del tramo" className="w-24" value={t.gasto?.moneda ?? 'VES'} onChange={(e) => cambiar(i, { gasto: { monto: t.gasto?.monto ?? '0', moneda: e.target.value as Moneda } })}>
                <option value="VES">Bs</option>
                <option value="USD">USD</option>
              </Seleccion>
            </div>
          </div>
        </div>
      ))}
      {tramos.length < 5 && (
        <Boton type="button" variante="fantasma" onClick={agregar}>
          + Agregar tramo
        </Boton>
      )}
    </div>
  )
}
